module.exports = __webpack_public_path__ + "img/tornado.08593a51.svg";